import {motion} from 'framer-motion'
import { useState, useEffect } from 'react';
import '../CSS/ContactLetterOpen.scss'
import ContactLetter from './ContactLetter';

const ContactOpened = ({setIsOpen, setDelaySent}) =>{
    const [entered, isEntered] = useState(false);
    const [invalidName, setInvalidName] = useState(false);
    const [formValues, setFormValues] = useState({
        name: "",
        email: "",
        message: ""
    })

    useEffect(()=>{
        isEntered(true)
    }, [])

    const encode = (data) =>{
        return Object.keys(data).map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
        .join('&')
    }

    const submitForm = (e) =>{
        e.preventDefault();
        const regName = /^[A-Za-z\s]+$/;
        if(!regName.test(formValues.name)){
            setInvalidName(true);
        }
        else{
            setDelaySent(true)
            setInvalidName(false)
            setIsOpen(false)

            fetch("/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: encode({ "form-name": "contact", ...formValues })
            })
                .then(() => console.log("Sent!"))
                .catch(error => alert(error));
        }
    }

    return(
        <motion.div className='opened'
        initial={{opacity: 0, y: 0}}
        animate={{opacity: 1, y: "25%"}}
        exit={{opacity: 0, y: 0}}
        transition={{duration: .5}}
        >
            <motion.div className='light-brown'
            initial={{y: 0}}
            animate={{y: "-65%"}}
            exit={{y: 0}}
            transition={{duration: .5}}>
            </motion.div>
            <motion.div className='letter-color'
            initial={{y: 0}}
            animate={{y: "0"}}
            exit={{y: 0}}
            transition={{duration: .5}}>
                <motion.button type='submit' form='form'
                animate={{y: [0, -5, 0, 5, 0]}}
                transition={{duration: 1, repeat: Infinity, ease: 'linear'}}>Send!</motion.button>
                <motion.div className='button-shadow'
                animate={{scale: [1, .7, .8, 1.1, 1], opacity: [.9, .7, .8, 1, .8]}}
                transition={{duration: 1, repeat: Infinity, ease: 'linear'}}></motion.div>
            </motion.div>
            <motion.div className='email-container'
            initial={{y: 0}}
            animate={{y: "-40%"}}
            exit={{y: 0}}
            transition={{duration: entered ? .5 : 1}}>
                <div className='email-blur'></div>
                <div className='email-top-blur'></div>
                <motion.div className='email'>
                    <h1>From: </h1>
                    <h2 onClick={() => setIsOpen(false)}>Close (x)</h2>
                    <ContactLetter 
                    submitForm={submitForm} 
                    formValues={formValues} 
                    setFormValues={setFormValues}
                    invalidName={invalidName}/>
                </motion.div>
                <div className='email-bottom-blur'></div>
            </motion.div>
        </motion.div>
    )
}

export default ContactOpened;